export default __webpack_public_path__ + "static/media/logo.fb7daaa5.png";